var map = {
	"./ArrowUpRight.svg": "4f76",
	"./AuthenticLabs.svg": "0a13",
	"./BCorp.svg": "d8f8",
	"./Back.svg": "8b17",
	"./CarrotDown.svg": "47cb",
	"./CarrotRight.svg": "efb8",
	"./Close.svg": "5ba3",
	"./Community.svg": "8a8a",
	"./CommunityChecked.svg": "00e9",
	"./Companies.svg": "9fd6",
	"./DialogClose.svg": "a85b",
	"./Diversity.svg": "cb02",
	"./DiversityChecked.svg": "ac92",
	"./Environment.svg": "e807",
	"./EnvironmentChecked.svg": "8e4e",
	"./FilterIndicator.svg": "2830",
	"./Ingredients.svg": "98e5",
	"./IngredientsChecked.svg": "364a",
	"./List.svg": "ef45",
	"./Manufacturing.svg": "33d0",
	"./ManufacturingChecked.svg": "50e6",
	"./RealLogo.svg": "4398",
	"./Search.svg": "8196",
	"./scanSymbol.svg": "7bc1",
	"./valuesSymbol.svg": "07ae"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";